const IMAGE_DATA_URI_RE = /^data:image\/[a-zA-Z0-9.+-]+(?:;[a-zA-Z0-9=:+-]+)*,/
const BASE64_CHARS_RE = /^[A-Za-z0-9+/]+={0,2}$/

function decodeBase64(value: string) {
  if (typeof globalThis.atob !== 'function') return null

  try {
    return globalThis.atob(value)
  } catch {
    return null
  }
}

function inferImageMimeType(base64: string) {
  const decoded = decodeBase64(base64)
  if (!decoded) return null

  if (decoded.startsWith('\x89PNG\r\n\x1a\n')) return 'image/png'
  if (decoded.startsWith('\xff\xd8\xff')) return 'image/jpeg'
  if (decoded.startsWith('GIF87a') || decoded.startsWith('GIF89a')) return 'image/gif'
  if (decoded.startsWith('RIFF') && decoded.slice(8, 12) === 'WEBP') return 'image/webp'
  if (decoded.startsWith('BM')) return 'image/bmp'

  const trimmed = decoded.trimStart()
  if (trimmed.startsWith('<svg') || trimmed.startsWith('<?xml')) return 'image/svg+xml'

  return null
}

function normalizeRawBase64(value: string) {
  const compact = value.replace(/\s+/g, '')

  if (!compact || compact.length < 16 || compact.length % 4 !== 0) return null
  if (!BASE64_CHARS_RE.test(compact)) return null

  return compact
}

export function getImageSrc(value: string | null | undefined) {
  const trimmed = value?.trim()
  if (!trimmed) return null

  if (IMAGE_DATA_URI_RE.test(trimmed)) return trimmed
  if (/^(https?:|blob:)/.test(trimmed)) return trimmed

  const normalized = normalizeRawBase64(trimmed)
  if (!normalized) return null

  const mimeType = inferImageMimeType(normalized)
  if (!mimeType) return null

  return `data:${mimeType};base64,${normalized}`
}
